export default "__VITE_ASSET__Ccq3D9FT__"